import * as API from '@/api'
import DEFINES from '@/defines'
import router from '../../router';
import {
    getField,
    updateField
} from 'vuex-map-fields';
//initial state
function initialState() {
  return {
    key: null,
    secret: null,
    selected_company_id: null
  }
}
const state = initialState()

// actions

const actions = {

  async login(context, payload) {
    var response = await API.auth.login(payload);
    context.commit('set_key', {
        key: response.key
    })
    return response;
},

  async deletePreviousSession(context, payload) {
    await API.auth.deletePreviousSession(payload);
  },

  async logout(context, payload) {

    //logout when you user is loggedin
    await API.auth.logout(payload.auth);

    context.dispatch('resetAll', {}, DEFINES.USE_ROOT);
    router.push({
      name: payload.redirect_to
    });

  },

  async verifyOtp(context, payload) {
    var response = await API.auth.verifyOtp(payload)
    context.commit('set_secret', {
      secret: response.secret
    })

    // set user profile
    context.commit (
      'user/set_profile',
      {
        profile: response.user,
      },
      DEFINES.USE_ROOT
    );
    // set user companies
    context.commit(
      'company/set_list', {
        companies: response.companies
      },
      DEFINES.USE_ROOT
    );

    return response;
  },

  async loginSuccess (context) {
    var all_companies = context.rootGetters['company/getCompanies'];
    if (all_companies.length) {
      context.dispatch ('setCompanyDetails', all_companies);
    } else {
      context.dispatch (
        'app/showMessage',
        {
          message: 'You do not have any company register in RMS',
          color: DEFINES.ERROR_COLOR,
        },
        DEFINES.USE_ROOT
      );

      context.dispatch ('logout');
    }
  },

  async setCompanyDetails (context, payload) {
    context.commit (
      'company/set_selected',
      {
        selected_company_id: payload[0].id,
      },
      DEFINES.USE_ROOT
    );

    // =========== Check For Three Conditions ============
    // 1. If user comes from a URL directly, then redirect to the requested URL path

    if (router.currentRoute.query.redirect) {
      return router.push (router.currentRoute.query.redirect);
    }

    // If user has only one company then redirect to films dashboard directly
    if (payload.length == 1) {
      return router.push ({
        name: 'Dashboard',
        params: {
          company_id: payload[0].id,
        },
      });
    }

    // If user has multiple companies then redirect to company switcher page
    if (payload.length > 1) {
      return router.push ({name: 'Companies'});
    }
  },
};

// getters
const getters = {
  getField,
  getCurrentSessionKey: (state) => {
    return state.key
  },
};

// mutations
const mutations = {
  async set_key(state, payload) {
    state.key = payload.key
  },

  async set_secret(state, payload) {
    state.secret = payload.secret
  },

  reset(state) {
    // acquire initial state
    const s = initialState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
